var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTvLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6 158.527V141.709H17.2C12.47 141.709 8.42227 140.064 5.0568 136.773C1.6856 133.477 0 129.516 0 124.891V23.9844C0 19.3595 1.6856 15.3989 5.0568 12.1026C8.42227 8.81196 12.47 7.16663 17.2 7.16663H154.8C159.53 7.16663 163.581 8.81196 166.952 12.1026C170.317 15.3989 172 19.3595 172 23.9844V124.891C172 129.516 170.317 133.477 166.952 136.773C163.581 140.064 159.53 141.709 154.8 141.709H120.4V158.527H51.6ZM17.2 124.891H154.8V23.9844H17.2V124.891Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvLarge);
export default __webpack_public_path__ + "static/media/tv-large.4009f1e5090e3ae9d48abba4de23d669.svg";
export { ForwardRef as ReactComponent };